/**
 * @Author: Kerem Koç <keremkoc>
 * @Date:   2018-01-25T02:48:53+03:00
 * @Email:  kerem@kocapps.com
 * @Filename: app.js
 * @Last modified by:   keremkoc
 * @Last modified time: 2018-02-24T18:54:23+03:00
 */
// require('script-loader!./js/main.js');
import './js/main.js';
// import './js/script.js';
